import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function usePrivilegeName(input: number) {
    const { t } = useTranslation();
    const [privilegeName, setPrivilegeName] = useState<string>(t("Privileges.Common"));

    useEffect(() => {
        switch(input)
        {
            case 0:
                setPrivilegeName(t("Privileges.Reader"));
                break;
            case 1:
                setPrivilegeName(t("Privileges.Editor"));
                break;
            case 2:
                setPrivilegeName(t("Privileges.Reader"));
                break;
            case 3:
                setPrivilegeName(t("Privileges.Organizer"));
                break;
            case 4:
                setPrivilegeName(t("Privileges.None"));
                break;
            case 5:
                setPrivilegeName(t("Privileges.Common"));
                break;
            default:
                setPrivilegeName(t("Privileges.None"));
                break;
        }
    }, []);

    return { privilegeName }
}